import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BankService } from '../interfaces';

import { BankDetails, Bank, BankDetailsResponse } from '../models';
import { Guid } from '@fitscovery/common/types';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from '../environment-injection';

@Injectable()
export class ApiBankService implements BankService {

  constructor(
    @Inject(APP_ENVIRONMENT) private env: Environment,
    private http: HttpClient
  ) { }

  getBanks(): Observable<Bank[]> {
    return <Observable<Bank[]>>this.http.get(`${this.env.azureFunctionsApi.partners}/banks`);
  }

  getBankDetailsByPartnerId(partnerId: Guid): Observable<BankDetailsResponse> {
    return <Observable<BankDetailsResponse>>this.http.get(`${this.env.azureFunctionsApi.partners}/partners/${partnerId}/partner-bank-information`);
  }

  createBankDetails(bank: BankDetails): Observable<any> {
    return this.http.post(`${this.env.azureFunctionsApi.partners}/partners/create-partner-bank-information`, bank);
  }

  updateBankDetails(bank: BankDetails): Observable<BankDetailsResponse> {
    return <Observable<BankDetailsResponse>>this.http.put(`${this.env.azureFunctionsApi.partners}/partners/${bank.partnerId}/update-partner-bank-information`, bank);
  }

}
